import React, { Component } from "react";
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageSectionTitle from "./LandingPageSectionTitle";
import LandingPageAverageMilesItem from "./LandingPageAverageMilesItem";
import { getMarketAnalysis } from "../../../shared/requests-api";
import Loading from "../../../../shared/Loading/Loading";

class LandingPageAverageMiles extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			isLoading: true,
			hasError: false
		};
	}

	getCompanyFromFidelityName(name) {
		switch (name) {
			case "TudoAzul":
				return "AZUL";
			case "Multiplus / Gold":
			case "Latam Pass":
			case "Multiplus":
				return "LATAM";
			case "Smiles":
				return "GOL";
			default:
				return "-";
		}
	}

	componentWillMount() {
		getMarketAnalysis(null)
			.then(response => {
				let companies = response.data;
				this.setState({
					data: companies,
					isLoading: false
				});
			})
			.catch(error =>
				this.setState({
					isLoading: false,
					hasError: true
				})
			);
	}

	render() {
		return (
			<LandingPageLayout id="average-miles" classAdd="offers-landing-page-average-miles">
				<LandingPageSectionTitle strongText="Valor médio" text="por programa de fidelidade" />
				<div className="offers-landing-page-average-miles__content">
					{!this.state.isLoading ? (
						this.state.hasError ? (
							<h3>Ocorreu um erro. Tente novamente mais tarde.</h3>
						) : (
							this.state.data
								.filter(fidelity => fidelity.name !== "Platinum / Black")
								.map((item, index) => <LandingPageAverageMilesItem key={index} fidelity={item} />)
						)
					) : (
						<Loading />
					)}
					<small>
						Os valores se referem à média das ofertas feitas nas MaxMilhas nos últimos 7 dias e
						podem sofrer alterações no momento da sua oferta.
					</small>
				</div>
			</LandingPageLayout>
		);
	}
}

export default LandingPageAverageMiles;
